<template>
  <div>
    <v-hover v-if="!hideShowAll" v-slot:default="{hover}">
      <v-card class="weekday-header pointer" color="primary" dark flat>
        <v-card-title class="justify-center">{{ trips.day }}</v-card-title>
        <v-overlay v-if="hover || loading" absolute color="secondary" opacity="1">
          <loader :yes="loading" color="white"/>
          <v-card-title v-if="!loading" class="text-center">Show trips</v-card-title>
        </v-overlay>
      </v-card>
    </v-hover>

    <v-card v-else class="weekday-header" color="primary" dark flat>
      <v-card-title class="justify-center">{{ trips.day }}</v-card-title>
      <v-overlay v-if="loading" absolute color="secondary" opacity="1">
        <loader :yes="loading" color="white"/>
      </v-overlay>
    </v-card>

    <v-container class="py-1 weekday-totals">
      <div style="display: flex;">
        <div class="py-2">
          <span class="totals">{{ t({s: 'sidebar.trips.dayTotals', component: 'Map'}) }} </span>
        </div>
        <div class="ml-auto py-2 mr-6">
          <span class="totals">
              <v-icon :size="12.5" class="mr-1">fal fa-arrows-h</v-icon>
              {{ Math.round((trips.totals.distance / 1000) * 100) / 100 }} km
          </span>
        </div>
        <div class="py-2 mr-3">
          <v-icon :size="12.5" class="mr-1">fal fa-clock</v-icon>
          {{ hhmmss(trips.totals.duration) }}
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import Loader from '@/components/Global/Loader'

export default {
  name: 'Header',
  props: {
    loading: Boolean,
    trips: Object,
    hideShowAll: {
      type: Boolean,
      default: false
    }
  },
  components: { Loader }
}
</script>

<style scoped>
.weekday-totals {
  font-size: 0.8em;
  font-weight: 500 !important;
  color: rgb(201, 114, 0) !important;
}

.pointer {
  cursor: pointer !important;
}

.weekday-header .v-card__title {
  text-align: center;
  font-size: 1em;
}

</style>
